import Close from "../../../images/newDesign/close.nocolor.svg";
import { Modal } from 'react-bootstrap';
import {useTranslation} from "react-i18next";
import {FilteringModalStyled} from "./FilteringModal.styled";
import {SvgIcon} from "../../../ui/SvgIcon";
import Button from "../../../common/Button";
import {useReducer} from "react";
import {SquareCheckbox} from "../../../ui/SquareCheckbox";

export function FilteringModal({ filters = {}, buildingTitle, onHide = () => null, onConfirm = () => null }) {

    const { t } = useTranslation();
    const [filterValues, dispatchFilterValues] = useReducer((s, a) => ({...Object.assign(s, a)}),  filters);

    return (
        <FilteringModalStyled show={true} onHide={onHide} centered>
            <Modal.Header>
                <div className="modal-title">
                    <span>{t('reports.debtListFilteringPopUp.title')}</span>
                    <span className="building-address">{buildingTitle}</span>
                </div>
                <button onClick={onHide}>
                    <SvgIcon href={Close} size={16}/>
                </button>
            </Modal.Header>
            <Modal.Body>
                <SquareCheckbox
                    checked={filterValues.thisMonthDebts}
                    onChange={check => dispatchFilterValues({ thisMonthDebts: check })}
                    label={t('reports.debtListFilteringPopUp.thisMontDebtsLabel')}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button rounded={false} onClick={() => onConfirm(filterValues)}>{t('common.buttons.confirm')}</Button>
            </Modal.Footer>
        </FilteringModalStyled>
    );
}
